import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { SignUpPayload } from '../generated/types';

const SIGN_UP_MUTATION = gql`
  mutation SignUp($email: String!, $password: String!, $passwordConfirmation: String!, $fullName: String!, $role: UserRoleType) {
    signUp(email: $email, password: $password, passwordConfirmation: $passwordConfirmation, fullName: $fullName, role: $role) {
      user {
        id
        email
        fullName
        role
      }
    }
  }
`;

export function useSignUp() {
  const [signUpMutation, { loading, error }] = useMutation<{ signUp: SignUpPayload }>(SIGN_UP_MUTATION);

  const signUp = async (
    email: string,
    password: string,
    passwordConfirmation: string,
    fullName: string,
    role?: string
  ) => {
    const { data } = await signUpMutation({
      variables: { email, password, passwordConfirmation, fullName, role },
    });
    return data?.signUp?.user;
  };

  return { signUp, loading, error };
}
